<template>
  <sui-modal v-model="modalOpen">
    <sui-modal-header>Extend the test duration</sui-modal-header>
    <sui-modal-content class="scrolling">
      <start-test-form
        extend="true"
        v-bind:submitButtonLabel="submitButtonLabel"
        v-bind:test="currentTest"
        v-on:saved="testExtended"
        v-bind:error="extendTestError"
        ref="startTestForm"
      />
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button negative v-on:click="hideExtendModal"> Cancel </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import StartTestForm from '@/components/tests/StartTestForm';
import { mapGetters } from 'vuex';

export default {
  name: 'ExtendTestModal',
  components: { StartTestForm },
  computed: {
    ...mapGetters({
      extendTestModalOpen: 'extendTestModalOpen',
      currentTest: 'currentTest',
      paging: 'testsPaging',
    }),
    modalOpen: {
      get() {
        return this.extendTestModalOpen;
      },
      set(isOpen) {
        this.hideExtendModal();
        return isOpen;
      },
    },
  },
  data() {
    return {
      submitButtonLabel: 'Extend test',
      extendModalOpen: false,
      extendTestError: null,
    };
  },
  watch: {
    extendTestModalOpen(val) {
      if (val) {
        this.extendTestError = null;
        this.$refs.startTestForm.reset();
      }
    },
  },
  methods: {
    hideExtendModal() {
      this.$store.dispatch('hideExtendTestModal');
    },
    testExtended() {
      this.extendTestError = null;
      this.$store.dispatch('extendTest', this.currentTest).then(
        () => {
          this.$store.dispatch('getPagedTests', this.paging);
          this.hideExtendModal();
        },
        (error) => {
          this.extendTestError = error.response.data;
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/ExtendTestModal.vue